"use strict";

var Prompt = require("app/shared/components/Prompt/prompt");
var UserSelectorContainer = require("app/shared/components/UserSelector/user-selector-container");
var InputText = require("app/shared/components/InputText/input-text");
var Tooltip = require("app/shared/components/Tooltip/tooltip");
var Icon = require("app/shared/components/Icon/icon");
var _ = require("underscore");
var Intl = require("intl");

var TeamPrompt = React.createClass({
  mixins: [ReactIntl.IntlMixin],
  propTypes: {
    team: React.PropTypes.shape({
      id: React.PropTypes.number,
      name: React.PropTypes.name,
      user_teams: React.PropTypes.arrayOf(
        React.PropTypes.shape({
          leader: React.PropTypes.number,
          user: React.PropTypes.object
      }))
    }),
    onClose: React.PropTypes.func,
    onConfirm: React.PropTypes.func,
    isOpen: React.PropTypes.bool,
    users: React.PropTypes.array,
    isSaving: React.PropTypes.bool,
    buttonText: React.PropTypes.string
  },

  getDefaultProps: function() {
    return {
      showTooltip: false,
      tooltipTitle: ""
    };
  },

  getInitialState: function() {
    return {
      id: "",
      name: "",
      leaders: [],
      members: []
    };
  },

  componentWillMount: function() {
    if (this.props.team) {
      this.setState({
        id: this.props.team.id,
        name: this.props.team.name,
        leaders: this.getLeaders(this.props.team.user_teams),
        members: this.getMembers(this.props.team.user_teams)
      });
    }
  },

  getLeaders: function(userTeams) {
    var leaderUserTeams = _.where(userTeams, { leader: 1 });
    return this.pluckUsers(leaderUserTeams);
  },

  getMembers: function(userTeams) {
    var memberUserTeams = _.where(userTeams, { leader: 0 });
    return this.pluckUsers(memberUserTeams);
  },

  pluckUsers: function(userTeams) {
    return _.pluck(userTeams, 'user');
  },

  handleOnChangeName: function(e) {
    this.setState({name: e.target.value});
  },

  isConfirmButtonDisabled: function() {
    var isUserSelected = this.validateSelection();
    var teamNameLength = this.state.name ? this.state.name.length : 0;
    var hasTeamName = teamNameLength !== 0;

    return !(isUserSelected && hasTeamName) || this.props.isSaving;
  },

  validateSelection: function() {
    return !(_.isEmpty(this.state.leaders) && _.isEmpty(this.state.members));
  },

  handleLeaderSelection: function(user) {
    this.setState({
      leaders: _.where(user, {checked: true})
    });
  },

  handleMemberSelection: function(user) {
    this.setState({
      members: _.where(user, {checked: true})
    });
  },

  handleConfirm: function() {
    var user_teams = this.buildUserTeams();
    var team = {
      name: this.state.name,
      user_teams: user_teams
    };

    if (this.state.id) {
      team.id = this.state.id;
    }
    this.props.onConfirm(team);
  },

  buildUserTeams: function() {
    var leaderUserTeams = _.map(this.state.leaders, function(leader) {
      return { user: leader, leader: 1 };
    });

    var memberUserTeams = _.map(this.state.members, function(member) {
      return { user: member, leader: 0 };
    });

    return _.union(leaderUserTeams, memberUserTeams);
  },

  promptTitle: function() {
    if (this.props.team && this.props.team.name) {
      return "Editar " + this.props.team.name;
    } else {
      return "Criação de uma nova Equipe";
    }
  },

  render: function(){
    var promptProps = {
      title: this.promptTitle(),
      hideWarningIcon: false,
      buttonText: "Salvar",
      buttonClasses: "btn btn-primary",
      isOpen: this.props.isOpen,
      onClose: this.props.onClose,
      onConfirm: this.handleConfirm,
      autoClose: false,
      buttonText: this.props.buttonText,
      tooltipTitle: this.props.tooltipTitle,
      showTooltip: this.props.showTooltip && this.isConfirmButtonDisabled()
    };

    return (
      <Prompt {...promptProps} disabledConfirmButton={this.isConfirmButtonDisabled()} type="confirm">
        <div className="w-700">
          <PromptSubtitle text="Qual é o nome da equipe?" classNames="ta-c">
            <TeamName teamName={this.state.name}
              handleOnChange={this.handleOnChangeName} />
          </PromptSubtitle>
          <div className="p-r mh-265">
            <PromptSubtitle text="Quem são os líderes?" helpText="Os líderes são usuários que têm acesso à carteira de cliente dos membros" classNames="ta-l d-ib f-l">
              <SelectTeam
                handleCustomSelection={this.handleLeaderSelection}
                users={this.props.users}
                selectedUsers={this.state.leaders} />
            </PromptSubtitle>
            <VerticalSeparator />
            <PromptSubtitle text="Quem são os membros?" helpText="Os membros são usuários que tem sua carteira de clientes compartilhada com os líderes e não têm acesso à carteira de outros membros" classNames="ta-l d-ib p-a r-0">
              <SelectTeam
                handleCustomSelection={this.handleMemberSelection}
                users={this.props.users}
                selectedUsers={this.state.members} />
            </PromptSubtitle>
          </div>
        </div>
      </Prompt>
    );
  }
});

const PromptSubtitle = (props) => (
  <div className={"mt-20 minw-300 " + props.classNames}>
    <span className="prompt-text fs-18 d-ib pl-10">{props.text}</span>
    <HelpTooltip text={props.helpText} />
    {props.children}
  </div>
);

const HelpTooltip = (props) => {
  if (props.text) {
    return (
      <Tooltip title={props.text}>
        <Icon icon="info-sign" className="d-ib fs-14 ml-5 c-888" />
      </Tooltip>
    );
  }
  return <span></span>; // TODO React 15.0 allows return null
};

const TeamName = (props) => (
  <div className="mt-10 w-500 m-a">
    <InputText placeholder="Nome da Equipe"
        value={props.teamName}
        onChange={props.handleOnChange}
        maxLength={60} />
  </div>
);

const SelectTeam = (props) => {
  var userSelectorContainerProps = {
    selectionType: "checkbox",
    color: "blue",
    border: "thick",
    className: "bg-none",
    handleCustomSelection: props.handleCustomSelection,
    forceState: true,
    users: _.chain(props.users).sortBy(function(user) { return user.name; })
      .sortBy(function(user) { return !user.active; }).value(),
    selectedUsers: props.selectedUsers
  };

  return <UserSelectorContainer {...userSelectorContainerProps} />;
};

const VerticalSeparator = () => (
  <div className="l-50pct t-20pct b-5pct p-a b-light"></div>
);

module.exports = TeamPrompt;



// WEBPACK FOOTER //
// ./app/shared/components/TeamSelector/team-prompt.jsx